"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransaction = void 0;
const schema_1 = require("./schema");
function createTransaction(signerId, publicKey, receiverId, nonce, actions, blockHash) {
    return new schema_1.Transaction({ signerId, publicKey, nonce, receiverId, actions, blockHash });
}
exports.createTransaction = createTransaction;
